import './style.scss'
import { CustomContainer, GridContainer, FlexRow, AppText, AppSpan } from "src/style"
import { IoIosStar, IoIosStarOutline } from "react-icons/io"
import { MdArrowOutward } from "react-icons/md"

export const ProductView: React.FC<any> = ({product, isComingSoon, onClick}) => {

    function handleClick () {
        if (onClick) onClick()
    }

    return (
        <CustomContainer
            width='28.95' height="35"
            radius="1.6" borderColor="#EAECF0"
            padding='2.4'
            //shadow='0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A'
            onClick={handleClick}
        >
            <GridContainer
                width='24.15'  height='16.5'
                bgColor='#F8F8FF' padding='1.5'
            >
                <CustomContainer width='14.5' height='10' overflow="hidden">
                    <img 
                        src={product.logoUrl} 
                        className='img-covered' 
                        style={{objectFit: 'contain'}}  
                    />
                </CustomContainer>
            </GridContainer>
            <FlexRow justifyContent='space-between' topMargin='1' gap='1.5'>
                <AppText
                    color='#101828' fontWeight="500" textSize='1.6' cursor="pointer"
                    style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
                >
                    {product.name}
                </AppText>
                <AppSpan
                    color='#000000' textSize='1.6'
                    hoverColor='#409089' cursor='pointer'
                >
                    <MdArrowOutward />
                </AppSpan>
            </FlexRow>
            { isComingSoon ?
                <CustomContainer
                    bgColor='#E7F6F5' radius='1.6'
                    width='9.3'
                    padding='0.2' topMargin='0.5'
                    leftPadding='0.5' rightPadding='0.5'
                >
                    <AppText
                        textSize='1.2' fontWeight='500'
                        color='#0A756F'
                    >
                        Coming soon
                    </AppText>
                </CustomContainer>
                :
                <FlexRow 
                    gap='2' topMargin='0.5'
                >
                    <FlexRow width='auto' sizeUnit='' gap='0.5'>
                        {
                            Array.from(Array(5).keys()).map((item) => {
                                return (
                                    <CustomContainer 
                                        width='auto' sizeUnit=''
                                        key={item}
                                    >
                                        { product.productStatistic?.averageRating >= (item + 1) ?
                                            <IoIosStar fill='#409089' fontSize='1.5rem' />
                                            : <IoIosStarOutline fill='#344054' fontSize='1.5rem' />
                                        }
                                    </CustomContainer>
                                )
                            })
                        }
                    </FlexRow>
                    <AppSpan textSize='1'>{(product.productStatistic?.averageRating || 0)?.toFixed(1)}</AppSpan>
                </FlexRow>
            }
            <AppText 
                topMargin='1' cursor="pointer"
                style={{whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word'}}
                className='truncate-multiline'
            >
                {product.description}
            </AppText>
        </CustomContainer>
    )
}